/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ chosen: NonNullable<unknown> }} Profile_Editors_Split_Offer_BodyInputs */

const en_us2_profile_editors_split_offer_body = /** @type {(inputs: Profile_Editors_Split_Offer_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generate a draft as ${i?.chosen}. You review it first, and nothing changes until you accept.`)
};

const pt_br2_profile_editors_split_offer_body = /** @type {(inputs: Profile_Editors_Split_Offer_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gere um rascunho em ${i?.chosen}. Você revisa antes, e nada muda até aceitar.`)
};

const es_419_profile_editors_split_offer_body = /** @type {(inputs: Profile_Editors_Split_Offer_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Genera un borrador como ${i?.chosen}. Lo revisas primero, y nada cambia hasta que lo aceptes.`)
};

const pt_pt2_profile_editors_split_offer_body = /** @type {(inputs: Profile_Editors_Split_Offer_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gera um rascunho em ${i?.chosen}. Revês antes, e nada muda até aceitares.`)
};

const fr_fr2_profile_editors_split_offer_body = /** @type {(inputs: Profile_Editors_Split_Offer_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Génère un brouillon en ${i?.chosen}. Tu le revois d'abord, et rien ne change tant que tu ne l'acceptes pas.`)
};

const de_de2_profile_editors_split_offer_body = /** @type {(inputs: Profile_Editors_Split_Offer_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erstelle einen Entwurf als ${i?.chosen}. Du prüfst ihn vorher, und nichts ändert sich, bis du ihn übernimmst.`)
};

const it_it2_profile_editors_split_offer_body = /** @type {(inputs: Profile_Editors_Split_Offer_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Genera una bozza in ${i?.chosen}. Prima la rivedi, e non cambia nulla finché non la accetti.`)
};

/**
* | output |
* | --- |
* | "Generate a draft as {chosen}. You review it first, and nothing changes until you accept." |
*
* @param {Profile_Editors_Split_Offer_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_split_offer_body = /** @type {((inputs: Profile_Editors_Split_Offer_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Split_Offer_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_split_offer_body(inputs)
	if (locale === "es-419") return es_419_profile_editors_split_offer_body(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_split_offer_body(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_split_offer_body(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_split_offer_body(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_split_offer_body(inputs)
	return en_us2_profile_editors_split_offer_body(inputs)
});
export { profile_editors_split_offer_body as "profile-editors.split_offer_body" }